import { z } from 'zod'

export const WarningSchema = z.object({
  message: z.string(),
})

export type Warning = z.infer<typeof WarningSchema>
